import { Injectable, inject } from '@angular/core';
import { IFrameworkComponentModel } from '../model/framework-component.model';
import { ENV_CONFIG, EnvironmentConfig } from '@libs/vc-core-lib';
import { IFrameworkComponentCriteriaDTO } from '../dto/framework-component.criteria.dto';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IReferenceTaskModel } from '../model/reference-task.model';

@Injectable({
    providedIn: 'root',
})
export class FrameworkComponentService {
    private readonly _httpClient: HttpClient = inject(HttpClient);
    private readonly _environment: EnvironmentConfig = inject(ENV_CONFIG);
    private readonly _frameworkComponentPath = 'framework-component';

    public getByName(frameworkComponentName: string): Observable<IFrameworkComponentModel> {
        return this._httpClient.get<IFrameworkComponentModel>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._frameworkComponentPath}`,
            { params: new HttpParams().append('name', frameworkComponentName) }
        );
    }

    public getById(frameworkComponentId: number): Observable<IFrameworkComponentModel> {
        return this._httpClient.get<IFrameworkComponentModel>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._frameworkComponentPath}`,
            { params: new HttpParams().append('id', frameworkComponentId) }
        );
    }

    public create(frameworkComponent: IFrameworkComponentModel): Observable<IFrameworkComponentModel> {
        return this._httpClient.post<IFrameworkComponentModel>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._frameworkComponentPath}`,
            frameworkComponent
        );
    }

    public update(frameworkComponent: IFrameworkComponentModel): Observable<IFrameworkComponentModel> {
        return this._httpClient.put<IFrameworkComponentModel>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._frameworkComponentPath}`,
            frameworkComponent,
            {
                params: new HttpParams().append('name', frameworkComponent.name),
            }
        );
    }

    public delete(frameworkComponentName: string): Observable<null> {
        return this._httpClient.delete<null>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._frameworkComponentPath}`,
            {
                params: new HttpParams().append('name', frameworkComponentName),
            }
        );
    }

    public getFrameworkNames(): Observable<string[]> {
        return this._httpClient.get<string[]>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._frameworkComponentPath}/all-names`
        );
    }

    public getComponentByName(name: string): Observable<IFrameworkComponentModel> {
        return this._httpClient.get<IFrameworkComponentModel>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._frameworkComponentPath}/full?name=${name}`
        );
    }

    public search(frameworkComponentCriteria: IFrameworkComponentCriteriaDTO): Observable<IFrameworkComponentModel[]> {
        return this._httpClient.post<IFrameworkComponentModel[]>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._frameworkComponentPath}/search`,
            frameworkComponentCriteria
        );
    }

    public list(ids: number[]): Observable<IFrameworkComponentModel[]> {
        return this._httpClient.post<IFrameworkComponentModel[]>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._frameworkComponentPath}/list`,
            ids
        );
    }

    public getRefTasksByComponentId(frameworkComponentId: number): Observable<IReferenceTaskModel[]> {
        return this._httpClient.get<IReferenceTaskModel[]>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._frameworkComponentPath}/reference-task/${frameworkComponentId}`
        );
    }

    public orderRefTasksByComponentId(frameworkComponentId: number, ids: number[]): Observable<IReferenceTaskModel[]> {
        return this._httpClient.put<IReferenceTaskModel[]>(
            `${this._environment.APP.VC_FRAMEWORK_BASE_URL}/${this._frameworkComponentPath}/reference-task/order/${frameworkComponentId}`,
            ids
        );
    }
}
